/**
 * Request Info Action - WHAT Section
 *
 * Edit mode UI for recurring info request automation.
 * This automation requests updates for workouts, assessments, or other information.
 *
 * V2 Reference: v2/app/templates/components/client-reminder-request.hbs
 *
 * Note: This is primarily a schedule-based automation with no specific "what" config.
 * The main configuration is timing (every X days/weeks/months).
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/Typography';

import { ActionWhatSectionProps } from '../automationActions';

/**
 * RequestInfo WHAT Section - Edit mode
 *
 * This action doesn't have specific "what" configuration - it's
 * purely schedule-driven to request client updates.
 */
export const RequestInfoWhatSection: FC<ActionWhatSectionProps> = () => {
  const { t } = useTranslation();

  return (
    <Typography color="text.secondary" fontStyle="italic">
      {t('automations.requestInfo.description')}
    </Typography>
  );
};

/**
 * RequestInfo What Summary Component
 */
export const RequestInfoWhatSummary: FC<{
  automation: ActionWhatSectionProps['automation'];
}> = () => {
  const { t } = useTranslation();

  return <>{t('automations.requestInfo.summary')}</>;
};
